import { jsx as _jsx } from "react/jsx-runtime";
import { Image20Regular } from "@fluentui/react-icons";
import React from "react";
export const DefaultIcon = () => {
    return (_jsx(Image20Regular, { style: {
            color: "#00000066",
        } }));
};
